import { ICoordinate } from '../../support/model/ICoordinate.ts';
import { formatCoordinates } from '../../support/helpers/format.ts';

export const Coordinates: React.FC<{coordinates?: ICoordinate}> = ({ coordinates }) => {
    const output = coordinates ? formatCoordinates(coordinates) : '';
    return <span>{output}</span>;
};
